import React, { useEffect, useState} from "react";
import Volume from "./volume";
import {Link, useHistory, useParams} from "react-router-dom";
import {getCoursesChapters, getCoursesSummary, getCoursesTeachers, postOrdersSubmit} from "../../service";
import {ChaptersData, SummaryData, TeachersData} from "../types";
import FixedTabs from "../../components/fixed-tabs";
import logo from '../../images/logo.png'
import MakePhoneCall from "../../components/makePhoneCall";
import VideoPlayer from "../../components/AliyunPlayer";
import usePhones from "../../routers/usePhones";
import {useLoading} from "../../components/loading/LoadingProvider";
import useUserInfo from "../../routers/useUserInfo";
import {useModal} from "../../components/modal";
import Empty from "../../components/empty";
import {httpReg} from "../../units";


let tabs = ['课程简介', '课程选集', '课程讲师']

interface Params {
    id: string
}

function CourseDetail() {

    const [active, setActive] = useState(0);
    const [videoActive, setVideo] = useState<number>(0);
    const [chapters, setChapters] = useState<Array<ChaptersData>>([]);
    const [summary, setSummary] = useState<SummaryData>();
    const [teacher, setTeacher] = useState<Array<TeachersData>>([]);
    const [cover,setCover] = useState<boolean>(false);
    const phones = usePhones()
    const his = useParams<Params>()
    const { push,goBack } = useHistory()
    const userInfo = useUserInfo(false)
    const loading = useLoading()
    const modal = useModal()


    useEffect(() => {
        getCoursesChapters({
            courseId: his.id
        }).then(res => {
            if (res.code === 1) {
                const lists = (res.data as Array<ChaptersData>)
                const f = lists.findIndex(item => item.available)
                setChapters(lists)
                setVideo(f)
            }
        })

        getCoursesSummary({
            courseId: his.id,
            userId:userInfo?.id
        }).then(res => {
            if (res.code === 1) {
                setSummary(res.data)
            }else{
                loading.showError(res.msg,() => {
                    goBack()
                })
            }
        })

        getCoursesTeachers({
            courseId: his.id
        }).then(res => {
            if (res.code === 1) {
                setTeacher(res.data)
            }
        })
    }, [])

    const  orderSubmit = () => {
        if(userInfo){
            loading.showLoading('订单生成中')
            postOrdersSubmit({
                userId:userInfo.id,
                courseId:his.id
            }).then(res => {
                if(res.code === 1){
                    loading.hideLoading()
                    push(`/user/do-pay/${ res.data.id }`)
                }else{
                    loading.showError()
                }
            })
        }else{
            modal.show({
                content:'此操作需要登录!',
                confirmText:'去登录',
                success:(res) => {
                    if(res.confirm){
                        push('/login')
                    }
                }
            })
        }
    }

    const getNextVideo = () => {
        const i = chapters.findIndex((item,index) => {
            return  index <= videoActive ? false : item.available
        })
        if(i !== -1){
            setVideo(i)
        }
    }


    return <div className='course-detail'>
        {
            (summary && summary.display) &&  <div className="video-box">
                {
                    (chapters.length > 0 && videoActive >= 0) && <VideoPlayer orderSubmit={ orderSubmit }  onEnd={ getNextVideo } courseId={his.id} id={ chapters[videoActive].id }/>
                }
            </div>
        }


        <FixedTabs tabs={tabs} onChange={(active) => setActive(active)} autoFixed/>

        <div className="section">
            {
                active === 0 && <div className="card">
                    {
                        summary && <div className="course-summary">
                            <div dangerouslySetInnerHTML={{ __html:summary.courseDetail }}/>
                        </div>
                    }

                </div>
            }

            {
                active === 1 && <div className="card">
                    {
                        chapters.length > 0 ? <Volume onChange={(active) => setVideo(active) } active={ videoActive } lists={chapters}/>
                        : <Empty>暂无课程相关信息</Empty>
                    }

                </div>
            }

            {
                active === 2 && <div className="card">
                    {/*<img src={ techter } alt=""/>*/}
                    {
                        teacher.length > 0 && <div className="teacher-list">

                            {
                                teacher.map((item,index) => {

                                    return <div className="teacher" key={index}>
                                        <div className="avatar" style={{backgroundImage: `url(${item.avatarUrl})`}}/>
                                        <div className="text">
                                            <h3><img src={ logo } alt="" style={{ width:'.28rem' }}/> {item.teacherName}</h3>
                                            <p className="s">{ item.title }</p>
                                            <p className='d'>{item.teacherSummary}</p>
                                        </div>
                                    </div>
                                })
                            }

                        </div>
                    }
                </div>
            }

        </div>
        {
            summary && <div className="fixed-space" style={{height: '1rem'}}>
                <div className="common-fixed">
                    <div className="common-btn" onClick={() => setCover(true)}>
                        <p className="iconfont">&#xe62e;</p>
                        <p>我要咨询</p>
                    </div>
                    {
                        !summary.available ? <div onClick={ orderSubmit } className="common-btn">立即学习</div> : (
                            httpReg(summary.examUrl || '') && <div onClick={ () => window.open(summary.examUrl) } className="common-btn">参加考试</div>
                        )
                    }

                </div>
            </div>
        }
        <MakePhoneCall show={ cover } telephone={ phones[3] } onClose={() => setCover(false)}/>
    </div>
}

export default CourseDetail;
